import { type TypedUseSelectorHook, useSelector } from 'react-redux'
import type { RootState } from '../redux-toolkits/store'

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
